$(document).ready(function() {
  // let vh = window.innerHeight * 0.01;
  // document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Кнопка "подробнее". Делает плавный скрол к первому экрану на главной
  $('.js-go-next').click(function() {
    $('html, body').animate({
      scrollTop: $("#mission").offset().top
    }, 1000);
  })
  $('.js-go-donate').click(function() {
    $('html, body').animate({
      scrollTop: $("#donate").offset().top
    }, 1000);
  })

  // Переключатель мобильного меню
  let windowWidth = window.innerWidth;
  $('.js-mobile-menu-show').click(function() {
    if (!$(this).hasClass('js-main-page')) {
      $(this).toggleClass('icon-burger').toggleClass('icon-cancel');
    } else {

      if (windowWidth >= 768) {
        $(this).toggleClass('icon-burger').toggleClass('icon-cancel');
        $('.b-logo').toggleClass('show');
        $('.logo--white').toggle();
        $('.logo--black').toggle();
      }
    }
    $(this).parents('.b-menu').toggleClass('show');
    $('.js-menu-mobile').toggleClass('show')

  })
  $('.js-mobile-menu-close').click(function() {
    $('.js-mobile-menu-show').addClass('icon-burger').removeClass('icon-cancel');
  })

  // Обработчик переключения языка
  $('.js-lang').click(function(e) {
    e.preventDefault()

    $('.js-lang').removeClass('active-lang')
    $(this).addClass('active-lang')
  })

  $('.js-menu-lang').click(function() {
    $(this).toggleClass('show')
    $('.js-menu-lang-container').toggleClass('show')
  })

  // Обработчик селектора
  $('.js-selector').click(function(e) {
    $(this).next('.js-selector-container').fadeToggle()
  })

  $('.js-selector-item').click(function(e) {
    e.preventDefault()
    var item = $(this).text();
    var link = $(this).attr('href') + '#payment'
    $('.js-selector').text(item)
    $('.js-selector-go-btn').attr('href', link);
    $('.js-selector-container').fadeOut();
  })

  $(document).mouseup(function(e) {
    var container = $(".js-selector").parent();
    if (container.has(e.target).length === 0) {
      $('.js-selector-container').fadeOut();
    }
  });

  // Обработчик валют
  $('.js-currencies button').click(function() {
    $('.js-currencies button').removeClass('active')
    $(this).addClass('active')
  })

  // обработчик поиска
  $('.js-search-btn').on('click', function(e) {
    if (!$('.js-search-input').val()) {
      e.preventDefault();
      $(this).toggleClass('show')
      $('.js-search-form').toggleClass('show')
      $('.js-search-input').toggleClass('show')
    }
  })

  $('.js-search-input').on('focusout', function() {
    if (!$(this).val()) {
      $('.js-search-btn').removeClass('show')
      $('.js-search-form').removeClass('show')
      $(this).removeClass('show')
    }
  })


  $(document).on('scroll', function() {
    let scrollValue = $(document).scrollTop();
    if (scrollValue >= 35 && windowWidth >= 768) {
      $('.b-menu').addClass('scrolled')
    } else {
      $('.b-menu').removeClass('scrolled')
    }
  })
})